// @flow

const config = window.menageConfig

// console.log('--> [CONFIG]', config)

export default config
